import {AxiosResponse} from "axios";
import {apiService} from "./ApiService";
import {IAppointmentTo, IIcsFileData, ISetAppointmentRequest} from "@/store/types/Appointment";
import {getCurrencyCode} from "@/i18n";
import {Appointment} from "@/components/modules/types/Calendar";
import CalendarHelper from "@/helpers/CalendarHelper";
import {CreateAppointmentRequest} from "@/services/types/CreateAppointmentRequest";
import * as ics from 'ics';

export class AppointmentService {

    private calendarHelper = new CalendarHelper();

    async getAppointments(internalOrderId: string, countryCode: string) {
        //TODO ENDCP-58 fix currency to general solution in avisierungsservice
        const currency = getCurrencyCode(countryCode);
        const response = await apiService.get(
          `Scheduling/${internalOrderId}`,
          {}
        );

        return response.data.map((appointment: IAppointmentTo) => {
            return {
                id: appointment.id,
                start: appointment.fromTime,
                end: appointment.toTime,
                timeslot: '',
                date: this.calendarHelper.getFormattedDate(appointment.fromTime),
                price: appointment.price,
                isRecommendation: appointment.isRecommended,
                currency: currency,
                priceId: appointment.priceId
            } as Appointment;
        }) as Appointment[];
    }

    async setAppointments(confirmedAppointment: ISetAppointmentRequest) {
      const payload: CreateAppointmentRequest = {
          id: confirmedAppointment.id,
          internalOrderIds: [confirmedAppointment.internalOrderId],         
          from: `${confirmedAppointment.fromTime}:00`,
          to: `${confirmedAppointment.toTime}:00`,
          scheduledDate: confirmedAppointment.appointment,
          price: Number(confirmedAppointment.costs),
          priceId: confirmedAppointment.priceId,
        };

        return apiService.post('SelfScheduling/BookAppointment', payload)
          .then((response: AxiosResponse) => {
            return response.data;
          });
    }

    async getAppointmentIcsFile(icsFileData: IIcsFileData){
          const icsFile = ics.createEvent({
              start: icsFileData.fromTime,
              end: icsFileData.toTime,
              title: icsFileData.emailSubject,
              location: icsFileData.address,
              htmlContent: `<!DOCTYPE HTML PUBLIC '-//W3C//DTD HTML 3.2//EN'><BODY>${icsFileData.emailBody}</BODY><HTML>`
          });
  
          return {data: icsFile.value};
  }
}

export const appointmentService = new AppointmentService();
